export default {
  "ThirdPartyChangeContents.Title1": "かんたんおすすめ設定",
  "ThirdPartyChangeContents.Text1":
    "データの提供先と種類について、まとめてかんたんに設定することができます",
  "ThirdPartyChangeContents.Title2": "個別詳細設定",
  "ThirdPartyChangeContents.Text2":
    "データの提供先と種類について個別に設定することができます",
  "ThirdPartyChangeContents.Button": "トップページへ戻る",
  "ThirdPartyChangeContents.Caution":
    "サービスのご利用に必要なデータ提供や法令で認められている範囲でお客さまの同意を得る必要がない場合のデータ提供は、変更できません",
}
